import { useState } from "react";
export function useForceUpdate() {
    var _a = useState(0), setValue = _a[1]; // integer state
    return function () { return setValue(function (value) { return ++value; }); }; // update the state to force render
}
//# sourceMappingURL=forceRender.js.map